<script>
import ModelIndex from "../models/index"

export default {
  extends: ModelIndex,
  page: {
    title: "Bank Accounts",
  },
  props: {
    cardTitle: {default() { return this.lodash.startCase(this.$t('bank_accounts.plural')) }},
    resourceRoute: {default: 'bank_accounts'},
    modelVariable: {default: 'bank_account'}
  },
  data() {
    return {
      title: this.lodash.upperFirst(this.$t('bank_accounts.plural')),
      items: [
        {
          text: this.lodash.upperFirst(this.$t('bank_accounts.plural')),
          href: "/bank_accounts",
          active: true,
        },
      ],
      filterColumns: {
        name: { type: String, label: this.lodash.upperFirst(this.$t('bank_accounts.name')) },
        code: { type: String, label: this.lodash.upperFirst(this.$t('bank_accounts.code')) },
        type: { type: String, label: this.lodash.upperFirst(this.$t('bank_accounts.type')) }
      }
    }
  },
  computed: {
    columns() {
      return {
        ['bank_account']: [
          { key: 'index', label: 'No', sortable: false, style: { width: '1%' } },
          {
            key: 'customer.name',
            label: this.lodash.upperFirst(this.$t('bank_accounts.customer')),
            thStyle: { minWidth: '125px' },
            sortable: true
          },
          {
            key: 'bank.name',
            label: this.lodash.upperFirst(this.$t('bank_accounts.bank')),
            thStyle: { minWidth: '175px' },
            sortable: true
          },
          {
            key: 'account_number',
            label: this.lodash.upperFirst(this.$t('bank_accounts.account_number')),
            thStyle: { minWidth: '200px' },
          },
          { key: 'action', class: 'text-center', style: { width: '1%' } }
        ],
      };
    },
  },
  methods: {
    delete(value) {
      return this.$axios.delete(`/bank_accounts/${this.getModelKey(value)}`)
    },
    fetchModels(page = 1) {
      return this.$axios.get('/bank_accounts', {
        params: {
          with: 'customer,bank',
          page: page,
          per_page: this.perPage,
          search: this.search,
          sort: `${this.sortBy === 'name' ? 'id':this.sortBy},${(this.sortDesc || this.sortBy === 'name') ? 'desc' : 'asc'}`,
          ...this.filterParams
        }
      }).then((response) => {
        const { data: { data, meta } } = response;
        this.models = data.map((datum) => ({
          ...datum,
          _denyShow: false,
          _denyEdit: false,
          _denyDelete: true
        }))
        this.page = Number(meta.current_page);
        this.perPage = Number(meta.per_page);
        this.from = Number(meta.from);
        this.total = Number(meta.total);

        this.stats = [
          {
            title: this.lodash.upperFirst(this.$t('bank_accounts.count')),
            value: this.$numeral(this.total).format('0,0 a'),
            valueTitle: this.$numeral(this.total).format('0,0'),
            icon: 'bx bx-user'
          },
        ]

        return response;
      }).catch((error) => this.failedAlert(error));
    }
  },
};
</script>
